module.exports = __webpack_public_path__ + "img/12_84.4af57038.png";